import React, { forwardRef } from 'react';
import { cn } from '@utils/cn';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, helperText, required, className, ...props }, ref) => {
    return (
      <div className="space-y-1">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              ref={ref}
              type="checkbox"
              className={cn(
                "h-4 w-4 rounded border-gray-300 text-ncaa-primary",
                "focus:ring-ncaa-primary focus:ring-2",
                error && "border-red-300 text-red-500 focus:ring-red-500",
                className
              )}
              {...props}
            />
          </div>
          
          {label && (
            <div className="ml-3 text-sm leading-5">
              <label className="font-medium text-gray-700">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
              </label>
            </div>
          )}
        </div>
        
        {error && (
          <p className="text-sm text-red-600 ml-7">{error}</p>
        )}
        
        {helperText && !error && (
          <p className="text-sm text-gray-500 ml-7">{helperText}</p>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';